export default __webpack_public_path__ + "static/media/customer-support.ed122f05.png";